import clsx from 'clsx';

import { Typography } from '../../typography';

import type { TypographyProps } from '../../typography';

import s from './Prefix.module.css';

type PrefixProps = Omit<TypographyProps<'span'>, 'component' | 'variant'>;

export const Prefix = ({ children, className, color = 'grey-light', ...props }: PrefixProps) => (
  <Typography className={clsx(s.prefix, className)} color={color} component="span" variant="inset-paragraph" {...props}>
    {children}
  </Typography>
);
